'use strict';exports.__esModule = true;var _isEmpty = require('lodash/isEmpty');var _isEmpty2 = _interopRequireDefault(_isEmpty);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _upperFirst = require('lodash/upperFirst');var _upperFirst2 = _interopRequireDefault(_upperFirst);
var _findMappedLocalization = require('../../cities/findMappedLocalization');
var _commons = require('../commons');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var isCityFirstPropType = function isCityFirstPropType(propType) {return (
    ['apartment', 'cottage', 'duplex', 'garden_apartment', 'penthouse'].includes(propType));};

var translatePropertyType = function translatePropertyType(propertyType, translate, locale) {return (
    propertyType === 'studio' && locale === 'he' ?
    (0, _commons.translateAndLowerCase)(translate, 'SEOSearchTitle', 'altPropertyTypes', 'studio') :
    (0, _commons.translateAndLowerCase)(translate, 'propertyTypesPlural', propertyType));};


var isBasicSearch = function isBasicSearch(params, locationSearch) {return (
    ((0, _isEmpty2.default)(params.types) || (0, _get2.default)(params, 'types.length') > 1) && (0, _isEmpty2.default)(locationSearch.en));};

var basicSearchStructurePattern = function basicSearchStructurePattern(optionType, part1, part2, locale) {return (
    locale === 'ru' ?
    optionType + ' ' + part1 :
    part1 + ' ' + optionType);};

var formatBasicSearchTitle = function formatBasicSearchTitle(optionType, translate, locale) {return (
    basicSearchStructurePattern(
    translate('SEOSearchTitle', 'optionType', optionType),
    translate('SEOSearchTitle', 'baseTitle', 'part1'),
    translate('SEOSearchTitle', 'baseTitle', 'part2'),
    locale));};

var isBasicSearchWithCity = function isBasicSearchWithCity(params, locationSearch) {return (
    ((0, _isEmpty2.default)(params.types) || (0, _get2.default)(params, 'types.length') > 1) && !(0, _isEmpty2.default)(locationSearch.en));};

var basicSearchWithCityStructurePattern = function basicSearchWithCityStructurePattern(city, optionType, part1, part2, locale) {
  switch (locale) {
    case 'he':
      return part1 + ' ' + optionType + ' ' + city;
    case 'ru':
      return optionType + ' ' + part1 + ' ' + city;
    case 'en':
    default:
      return part1 + ' ' + optionType + ' ' + city;}

};

var formatBasicSearchWithCityTitle = function formatBasicSearchWithCityTitle(city, optionType, translate, locale) {return (
    basicSearchWithCityStructurePattern(
    city,
    translate('SEOSearchTitle', 'optionType', optionType),
    translate('SEOSearchTitle', 'baseTitleWithCity', 'part1'),
    translate('SEOSearchTitle', 'baseTitleWithCity', 'part2'),
    locale));};

var isSearchWithPropertyType = function isSearchWithPropertyType(params, locationSearch) {return (
    !(0, _isEmpty2.default)(params.types) && (0, _isEmpty2.default)(locationSearch.en));};

var formatSearchWithPropertyTypeTitle = function formatSearchWithPropertyTypeTitle(propertyType, optionType, translate, locale) {
  var translatedPropType = translatePropertyType(propertyType, translate, locale);
  var translatedOptionType = translate('SEOSearchTitle', 'optionType', optionType);
  var translatedAltOptionType = translate('SEOSearchTitle', 'altOptionType', optionType);
  switch (locale) {
    case 'he':
      if (propertyType === 'apartment') {
        var part1 = translate('SEOSearchTitle', 'searchTitleWithPropertyType', 'part1');
        return part1 + ' ' + translatedPropType + ' ' + translatedOptionType;
      }
      if (propertyType === 'cottage') {
        var cottage1 = translate('SEOSearchTitle', 'altPropertyTypes', 'cottage1');
        var cottage2 = translate('SEOSearchTitle', 'altPropertyTypes', 'cottage2');
        var _part = translate('SEOSearchTitle', 'searchTitleWithPropertyType', 'part1');
        if (optionType === 'rent') {
          return _part + ' ' + cottage2 + ' ' + translatedOptionType;
        }
        return cottage1 + ' ' + translatedOptionType + ', ' + cottage2 + ' ' + translatedOptionType;
      }
      if (propertyType === 'duplex' || propertyType === 'loft' || propertyType === 'penthouse') {
        var apartments = (0, _commons.translateAndLowerCase)(translate, 'propertyTypesPlural', 'apartment');
        var singlePropType = (0, _commons.translateAndLowerCase)(translate, 'propertyTypes', propertyType);
        return translatedPropType + ' ' + translatedOptionType + ', ' + apartments + ' ' + singlePropType + ' ' + translatedOptionType;
      }
      if (propertyType === 'garden_apartment') {
        var altGardenApt = translate('SEOSearchTitle', 'altPropertyTypes', 'garden_apartment');
        return translatedPropType + ' ' + translatedOptionType + ', ' + altGardenApt + ' ' + translatedOptionType;
      }
      return translatedPropType + ' ' + translatedOptionType;
    case 'ru':
      if (propertyType === 'apartment') {
        return translatedOptionType + ' ' + translatedPropType + ', ' + translatedPropType + ' ' + translatedAltOptionType;
      }
      if (propertyType === 'cottage') {
        var _cottage = translate('SEOSearchTitle', 'altPropertyTypes', 'cottage1');
        var _cottage2 = translate('SEOSearchTitle', 'altPropertyTypes', 'cottage2');
        return translatedOptionType + ' ' + _cottage + ', ' + _cottage2 + ' ' + translatedAltOptionType;
      }
      return translatedPropType + ' ' + translatedAltOptionType;
    case 'en':
      if (optionType === 'rent' && propertyType === 'cottage') {
        var homes = translate('SEOSearchTitle', 'searchTitleWithPropertyType', 'altCottage', 'homes');
        var houses = translate('SEOSearchTitle', 'searchTitleWithPropertyType', 'altCottage', 'houses');
        return homes + ' ' + translatedOptionType + ', ' + houses + ' ' + translatedOptionType;
      }
      return translatedPropType + ' ' + translatedOptionType;
    default:
      return translatedPropType + ' ' + translatedOptionType;}

};

var isSearchWithTypeAndCity = function isSearchWithTypeAndCity(params, locationSearch) {return (
    !(0, _isEmpty2.default)(params.types) && !(0, _isEmpty2.default)(locationSearch.en));};

var formatTitleWithTypeAndCity = function formatTitleWithTypeAndCity(propertyType, optionType, formattedCity, mappedCity, translate, locale) {
  var translatedPropType = translatePropertyType(propertyType, translate, locale);
  var translatedOptionType = translate('SEOSearchTitle', 'optionType', optionType);
  var altOptionType = translate('SEOSearchTitle', 'altOptionType', optionType);
  switch (locale) {
    case 'he':
      if (propertyType === 'cottage') {
        var cottage1 = translate('SEOSearchTitle', 'altPropertyTypes', 'cottage1');
        var cottage3 = translate('SEOSearchTitle', 'altPropertyTypes', 'cottage3');
        return cottage1 + ' ' + translatedOptionType + ' ' + formattedCity + ', ' +
        cottage3 + ' ' + translatedOptionType + ' ' + formattedCity;
      }
      if (propertyType === 'duplex' || propertyType === 'loft' || propertyType === 'penthouse') {
        var apartments = (0, _commons.translateAndLowerCase)(translate, 'propertyTypesPlural', 'apartment');
        var singlePropType = (0, _commons.translateAndLowerCase)(translate, 'propertyTypes', propertyType);
        return translatedPropType + ' ' + translatedOptionType + ', ' +
        apartments + ' ' + singlePropType + ' ' + translatedOptionType + ' ' + formattedCity;
      }
      if (propertyType === 'garden_apartment') {
        var altGardenApt = translate('SEOSearchTitle', 'altPropertyTypes', 'garden_apartment');
        return translatedPropType + ' ' + translatedOptionType + ', ' +
        altGardenApt + ' ' + translatedOptionType + ' ' + formattedCity;
      }
      return translatedPropType + ' ' + translatedOptionType + ' ' + formattedCity;
    case 'ru':
      if (propertyType === 'apartment') {
        return translatedOptionType + ' ' + translatedPropType + ' ' + formattedCity;
      }
      if (propertyType === 'cottage') {
        var _cottage3 = translate('SEOSearchTitle', 'altPropertyTypes', 'cottage1');
        return translatedOptionType + ' ' + _cottage3 + ' ' + formattedCity;
      }
      return translatedPropType + ' ' + altOptionType + ' ' + formattedCity;
    case 'en':
    default:
      if (propertyType === 'cottage' && optionType === 'buy') {
        var houses = translate('SEOSearchTitle', 'searchTitleWithPropertyType', 'altCottage', 'houses');
        return (mappedCity || '') + ' ' + houses + ' ' + translatedOptionType;
      }
      if (propertyType === 'loft') {
        var singleLoft = (0, _commons.translateAndLowerCase)(translate, 'propertyTypes', 'loft');
        var _apartments = (0, _commons.translateAndLowerCase)(translate, 'propertyTypesPlural', 'apartment');
        return (mappedCity || '') + ' ' + singleLoft + ' ' + _apartments + ' ' + translatedOptionType;
      }
      if (isCityFirstPropType(propertyType)) {
        return (mappedCity || '') + ' ' + translatedPropType + ' ' + translatedOptionType;
      }
      return translatedPropType + ' ' + translatedOptionType + ' ' + formattedCity;}

};

var formatBaseSentence = function formatBaseSentence(routeData, translate) {var

  locale =



  routeData.locale,optionType = routeData.optionType,_routeData$params = routeData.params,params = _routeData$params === undefined ? {} : _routeData$params,_routeData$locationSe = routeData.locationSearch,locationSearch = _routeData$locationSe === undefined ? {} : _routeData$locationSe;

  var mapped = (0, _findMappedLocalization.getMappedLocation)(locationSearch, locale);
  var city = mapped ?
  (0, _findMappedLocalization.formatLocation)(mapped, translate, locale) :
  '';
  if (isBasicSearch(params, locationSearch)) {
    return formatBasicSearchTitle(optionType, translate, locale);
  }
  if (isBasicSearchWithCity(params, locationSearch)) {
    return formatBasicSearchWithCityTitle(city, optionType, translate, locale);
  }
  if (isSearchWithPropertyType(params, locationSearch)) {
    return formatSearchWithPropertyTypeTitle(params.types[0], optionType, translate, locale);
  }
  if (isSearchWithTypeAndCity(params, locationSearch)) {
    return formatTitleWithTypeAndCity(params.types[0], optionType, city, mapped, translate, locale);
  }
  return null;
};

var formatTitle = function formatTitle(routeData, translate) {var _routeData$params2 =


  routeData.params,params = _routeData$params2 === undefined ? {} : _routeData$params2;
  var baseSentence = formatBaseSentence(routeData, translate);
  if (!baseSentence) {
    return '';
  }
  var formattedCase = baseSentence ? (0, _upperFirst2.default)(baseSentence) : null;
  var roomsString = (0, _commons.getRoomsString)(params, translate);
  if (!(0, _isEmpty2.default)(roomsString)) {
    return formattedCase + ' ' + roomsString;
  }
  return formattedCase;
};exports.default =

formatTitle;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/seo/residense/title.js
// module id = 3166
// module chunks = 0